module.exports = __webpack_public_path__ + "img/A member of-01.c79fa740.png";